const routes = [
    {
        path: "/student/sessions/registration/:studentProgramId",
        component: () => import("../pages/Registration.vue"),
        meta: {
            isAuthenticated: true,
            permission:'studentsession_registration'
        }
    },
    {
        path: "/student/sessions/registration",
        component: () => import("../pages/Registration.vue"),
        meta: {
            isAuthenticated: true,
            permission:'studentsession_registration'
        }
    }
];

export default routes;
